export default "__VITE_ASSET__8cdfdbda__"